import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["clearFilters", "setSearchString", "cancel", "searchString", "className"];
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { Button, SearchField } from '@carnica/ui-kit';
import { cnBem } from '@carnica/utils';
import { selectIsFiltersVisible, selectSearch, setIsFiltersVisible, setSearch as setStoreSearch, setSortType as setStoreSortType } from "../../../../entities/filters/model";
import { useDebounce } from "../../../../shared/lib";
import styles from "./styles.pcss";
var cnSearch = cnBem('search', styles);
var SearchRender = function SearchRender(_ref) {
  var clearFilters = _ref.clearFilters,
    setSearchString = _ref.setSearchString,
    cancel = _ref.cancel,
    searchString = _ref.searchString,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var debouncedSetFilterString = useDebounce(setSearchString, 600);
  useEffect(function () {
    debouncedSetFilterString((search === null || search === void 0 ? void 0 : search.trim()) !== '' ? search : undefined);
  }, [search]);
  useEffect(function () {
    if (!searchString ? true : !(search !== null && search !== void 0 && search.includes(searchString))) {
      setSearch(searchString !== null && searchString !== void 0 ? searchString : '');
    }
  }, [searchString]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnSearch(null, [className])
  }, otherProps), /*#__PURE__*/React.createElement(SearchField, {
    autoFocus: true,
    className: cnSearch('input'),
    onChange: setSearch,
    onClear: clearFilters,
    value: search
  }), /*#__PURE__*/React.createElement(Button, {
    className: cnSearch('button'),
    mode: "inline",
    onClick: cancel
  }, "\u043E\u0442\u043C\u0435\u043D\u0430"));
};
var mapStateToProps = function mapStateToProps(store) {
  return {
    searchString: selectSearch(store),
    shouldRender: selectIsFiltersVisible(store)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    clearFilters: function clearFilters() {
      dispatch(setStoreSortType('none'));
      dispatch(setStoreSearch(undefined));
    },
    cancel: function cancel() {
      return dispatch(setIsFiltersVisible(false));
    },
    setSearchString: function setSearchString(str) {
      return dispatch(setStoreSearch(str));
    }
  };
};
export var Search = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag())(SearchRender);